import {createRoot} from 'react-dom/client';

import ApplicationLayout from '@js/components/layouts/application';

require('@js/common');

const root = createRoot(document.getElementById('themes-component'));
root.render(
    <ApplicationLayout componentId="themes-component"/>
);
